<template>
    <div>
        <div class="job-filter" style="display:flex;justify-content:space-between">
            <div>
                <button class="btn btn-primary" :class="{ 'disabled': this.isBusy }" @click="openFilter">Filter</button>
                <span v-if="filtersAreActive" style="padding-left:5px;position:relative;top:2px">
                    Filters are Active
                    <a href="#" :class="{ 'disabled': this.isBusy }" @click.prevent="cancelFilter()">Cancel filters</a>
                </span>

                <span style="padding-left:15px;position:relative;top:2px">Show jobs:</span>
                <button class="btn"
                        :class="{ 'btn-secondary': activity !== 'active', 'btn-primary': activity === 'active', 'disabled': this.isBusy }"
                        @click="activity = 'active'; pageIndex = 0; refresh()">Active
                </button>
                <button class="btn"
                        :class="{ 'btn-secondary': activity !== 'inactive', 'btn-primary': activity === 'inactive', 'disabled': this.isBusy }"
                        @click="activity = 'inactive'; pageIndex = 0; refresh()">Inactive
                </button>

                <a :href="url(`/admin/employer/${employerId}/custom-questions`)" class="btn btn-primary pull-right" style="margin-left: 20px;">
                    <i class="fa fa-question-circle" aria-hidden="true"></i> Custom Questions
                </a>

                <btn :cssClass="`btn btn-info pull-right` + (this.isBusy || !this.pagingStats.totalRecords ? ' disabled' : '')"
                     :click="exportCsv"
                     :icon="`fa-fw fad fa-download`"
                     style="margin-left: 20px;">
                    Export CSV
                </btn>
            </div>

            <div v-if="pagingStats.minRecord > 0">
                <span style="position:relative;top:2px;padding-right:5px">
                    Jobs {{ pagingStats.minRecord }} - {{ pagingStats.maxRecord }} out of {{ pagingStats.totalRecords }}
                </span>
                <button v-if="pagingStats.lastIndex > 0"
                        class="btn btn-primary"
                        :class="{ 'disabled': this.pageIndex === 0 || this.isBusy }"
                        @click="prevPage()">«
                </button>
                <button v-if="pagingStats.lastIndex > 0"
                        class="btn btn-primary"
                        :class="{ 'disabled': this.pageIndex >= this.pagingStats.lastIndex  || this.isBusy }"
                        @click="nextPage()">»
                </button>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <tbody>
                <tr>
                    <th>Last Update</th>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Campaigns</th>
                    <th>Pricing</th>
                    <th>Categories</th>
                    <th>Experience</th>
                    <th>States</th>
                    <th>Referrer</th>
                    <th></th> <!--detail link-->
                    <th></th> <!--editLP link-->
                    <th></th>
                </tr>
                <tr v-if="isBusy">
                    <td colspan="11" class="text-center">
                        <i class="fa fa-spinner fa-pulse" style="font-size:3rem"></i>
                    </td>
                </tr>
                <tr v-else-if="jobs.length === 0">
                    <td colspan="11" class="text-center">No jobs found</td>
                </tr>
                <template v-else>
                    <tr v-for="(job, index) in jobs" :class="!job.isActive ? 'job-inactive' : ''">
                        <td>
                            <div>
                                {{ job.lastCopyUpdate }}
                            </div>
                            <div class="label label-danger" v-if="job.isOutdated">
                                {{ job.monthsOld }} months old
                            </div>
                        </td>
                        <td>{{ job.id }}</td>
                        <td>
                            <a :href="job.viewUrl">{{ job.title }}</a>

                            <span v-if="job.isFeedGenerated" class="label label-danger">Feed</span>
                            <div v-if="job.adminDescription">
                                <span style="font-style:italic">{{ job.adminDescription }}</span>
                            </div>
                        </td>
                        <td>
                            <div v-for="c in job.campaigns">{{ c }}</div>
                        </td>
                        <td>
                            <i v-if="job.isPricingSet" class="fa fa-money"
                               style="color:green;font-weight:bold;font-size:1.33em;" title="Pricing Is Set"></i>
                            <i v-else class="fa fa-money" style="color:#e64e42;font-weight:bold;font-size:1.33em;"
                               title="Pricing NOT Set"></i>
                        </td>
                        <td style="max-width:300px;overflow-wrap:break-word;">
                            <div v-for="tag in job.jobCategory" style="display:inline-block;margin-bottom:5px;">
                                <span class="label" :class="{ 'label-default' : (tag !== 'Owner Operators'), 'label-primary' : (tag === 'Owner Operators') }" style="margin-right:5px">{{ tag }}</span>
                            </div>
                        </td>
                        <td>min: {{ job.minCdlXp }} <br>max: {{ job.maxCdlXp }}</td>
                        <td>
                            <span style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:300px;display:inline-block">{{ job.stateCodes }}</span>
                            <br>
                            {{ job.statesCount ? job.statesCount + (job.statesCount === 1 ? ' state' : ' states' ) : '' }}
                        </td>
                        <td>{{ job.referrer }}</td>
                        <td>
                            <a :href="getJobDetailUrl(job)">detail</a>
                        </td>
                        <td>
                            <a :href="getJobEditLpUrl(job)">edit LP</a>
                        </td>
                        <td v-if="isJobBusy[index] === true" class="text-center">
                            <i class="fa fa-spinner fa-pulse"></i>
                        </td>
                        <td v-else-if="job.isActive">
                            <a href="#" @click.prevent="toggleJobActivity('inactivate', index)">inactivate</a>
                        </td>
                        <td v-else-if="!job.isActive">
                            <a href="#" @click.prevent="toggleJobActivity('reactivate', index)">reactivate</a>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>

        <job-list-filter
                v-if="showFilter"
                :show="showFilter"
                :filterData="filterData"
                :filterOptions="filterOptions"
                @apply="applyFilter"
                @close="showFilter = false"
        ></job-list-filter>

        <employer-notes-wrapper :employer-id="employerId" />
    </div>
</template>

<script>
import JobListFilter from './job-list-filter';

const defaultFilters = {
        states: [],
        campaign: [],
        title: '',
        admin_description: '',
        id: '',
        feed: '',
    };

export default {
    components: { JobListFilter },
    props: {
        employerId: { type: Number, required: true },
        filterOptions: { type: Object, required: true },
    },
    data() {
        return {
            isBusy: false,
            isJobBusy: {},
            jobs: [],
            filterData: Object.assign({}, defaultFilters),
            activity: 'active',
            showFilter: false,
            pageIndex: 0,
            pagingStats: {
                lastIndex: 0,
                totalRecords: 0,
                minRecord: 0,
                maxRecord: 0,
            },
        };
    },
    computed: {
        filtersAreActive() {
            return !_.isEqual(this.filterData, defaultFilters);
        },
    },
    methods: {
        refresh(firstTime) {
            const $this = this;
            $this.isBusy = true;

            if(firstTime === true)
                this.setFilterFromUrlParam();

            let href = window.location.href;
            let filterEnc = btoa(JSON.stringify({}));
            if(this.filtersAreActive) filterEnc = this.getFilterUrlEncVal();
            href = this.replaceUrlParam(href, 'filter', filterEnc);
            history.pushState(history.state, document.title, href);


            axios.post(url(`admin/employer/${$this.employerId}/jobs/data`), {
                activity: $this.activity,
                index: $this.pageIndex,
                filterData: $this.filterData,
            })
                 .then(response => {
                     if (response.data.jobs === 'undefined' || response.data.pagingStats === 'undefined') {
                         throw Error('Jobs couldn\'t be loaded.');
                     }
                     $this.jobs = Object.assign({}, response.data.jobs);
                     $this.pagingStats = Object.assign({}, response.data.pagingStats);
                 })
                 .catch(err => {
                     $this.$message.error(`Error: ${err.message}`);
                 })
                 .finally(() => {
                     $this.isBusy = false;
                 });
        },
        toggleJobActivity(type, jobIndex) {
            const $this = this;
            const jobId = $this.jobs[jobIndex].id;
            const urlAddress = `admin/jobs/${jobId}/` + (type === 'inactivate' ? 'suspend' : 'resume');
            Vue.set($this.isJobBusy, jobIndex, true);

            axios.get(url(urlAddress))
                 .then(response => {
                     if (response.data.success === 'undefined' || !response.data.success) {
                         throw Error('Action could not be performed.');
                     }
                     Vue.set($this.jobs[jobIndex], 'isActive', (type === 'reactivate'));
                 })
                 .catch(err => {
                     $this.$message.error(`Error: ${err.message}`);
                 })
                 .finally(() => {
                     Vue.delete($this.isJobBusy, jobIndex);
                 });
        },
        openFilter() {
            this.showFilter = true;
        },
        cancelFilter() {
            this.filterData = Object.assign({}, defaultFilters);
            this.pageIndex = 0;
            this.refresh();
        },
        applyFilter(filterData) {
            this.filterData = Object.assign({}, filterData.filters);
            this.pageIndex = 0;
            this.refresh();
        },
        setFilterFromUrlParam() {
            let query = this.getQueryParams(document.location.search);
            if(!query.filter) return;
            try {
                let filterJson = atob(query.filter);
                let fdata = JSON.parse(filterJson);
                if(fdata.activity) this.activity = fdata.activity;
                if(fdata.filterData) this.filterData = fdata.filterData;
            } catch(e) {
                console.error(e);
            }
        },
        getFilterUrlEncVal() {
            let fdata = {
                activity: this.activity,
                filterData: ( this.filtersAreActive ? this.filterData : defaultFilters ),
            };
            return btoa(JSON.stringify(fdata));
        },
        getJobEditLpUrl(job) {
            //const filter = this.getFilterUrlEncVal();
            //return this.replaceUrlParam(job.editLpUrl, 'filter', filter);
            return job.editLpUrl;
        },
        getJobDetailUrl(job) {
            const filter = this.getFilterUrlEncVal();
            return this.replaceUrlParam(job.detailUrl, 'filter', filter);
        },
        replaceUrlParam(url, paramName, paramValue)
        {
            if (paramValue == null) {
                paramValue = '';
            }
            var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
            if (url.search(pattern)>=0) {
                return url.replace(pattern,'$1' + paramValue + '$2');
            }
            url = url.replace(/[?#]$/,'');
            return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
        },
        getQueryParams(qs) {
            qs = qs.split('+').join(' ');

            var params = {},
                tokens,
                re = /[?&]?([^=]+)=([^&]*)/g;

            while (tokens = re.exec(qs)) {
                params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
            }

            return params;
        },
        prevPage() {
            if (this.pageIndex >= 1) {
                this.pageIndex--;
                this.refresh();
            }
        },
        nextPage() {
            if (this.pageIndex < this.pagingStats.lastIndex) {
                this.pageIndex++;
                this.refresh();
            }
        },
        exportCsv() {
            const filters = this.getFilterUrlEncVal();
            return axios.get(url(`admin/employer/${this.employerId}/jobs/export-csv`), {
                params: { filters: filters },
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'jobs.csv');
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
        },
    },
    mounted() {
        this.refresh(true);
    },
};
</script>

<style scoped>
    .job-inactive {
        background: #ebcaca !important;
    }

    .job-filter {
        background: #fefefe;
    }
</style>
